define(['jquery', 'datepicker-il8n', 'settings', 'erv_customvalidationsummary', 'erv_checks', 'erv_formatting', 'erv_tagit', 'responsive_common', 'episerver_forms_helpers', 'userway_helpers'], function ($, il8n, Settings, ValidationSummary, ERVChecks, ERVFormatting, ERVTagit, ERVResponsiveCommon, EpiserverFormsHelpers, UserwayHelpers) {
	var ERVForms = function () {
		var self = this;

		self.settings = Settings;
		self.userwayHelpers = UserwayHelpers;
		self.validationSummary = new ValidationSummary();
		self.checks = new ERVChecks();
		self.ervTagit = new ERVTagit();
		self.formatting = new ERVFormatting();
		self.datepickerTranslations = new il8n();
		self.responsiveCommon = new ERVResponsiveCommon();
		self.episerverFormsHelpers = new EpiserverFormsHelpers();
		self.$ervBody = $('#erv-body');

		if (typeof (Event) === 'function') {
			self.inputEvent = new Event('input', { 'bubbles': true });
		} else {
			self.inputEvent = document.createEvent('Event');
			self.inputEvent.initEvent('input', true, true);
		}

		self.loadDatePickerDefaults = function () {
			self.datepickerTranslations = new il8n();

			$.datepicker.setDefaults($.datepicker.regional[$('html').data('orglang')]);
			$.datepicker.setDefaults({
				changeMonth: true,
				changeYear: true,
				numberOfMonths: 1,
				minDate: 0,
				showAnim: '',
				dateFormat: $.datepicker.regional[$('html').data('orglang')].dateFormat,
				onSelect: function () {
					var $input = $(this);

					$input[0].dispatchEvent(self.inputEvent);
					$input.change();

					if ($input.data('val') === true) {
						self.dateValidation($input);
					}
				},
				beforeShow: function (element) {
					self.calendarBeforeShow(element);
				}
			});
		}

		$(document).ready(function () {
			self.loadDatePickerDefaults();
		});

		//This function is implemented to fix racing condition with EPi Forms code as it was overriding the default settings of ERV datepicker.
		self.isDatePickerInitializedByErvCode = function () {
			return $.datepicker.regional.da !== undefined;
		}

		//if button has show-loader class, set form in blocked mode. only for postback forms.
		//use when a page/block doesn't have it's own js-file
		self.initFormWithLoader = function () {
			var $showLoaders = self.$ervBody.find('.show-loader');

			if ($showLoaders.length === 0) {
				return false;
			}

			$showLoaders.on('click', function (e) {
				var $element = $(this),
					$form = $element.parents('form');

				// if already blocked, then nothing to do here
				if ($form.length === 0 || $form.hasClass('.loading')) {
					e.preventDefault();
					return;
				}

				if ($form.valid()) {
					self.activateLoading($form, false);
				}
			});
		}

		//currently only used for premade booking (form.cshtml)
		self.setEnterTriggerClick = function () {
			self.$ervBody.find('[data-js="enter-trigger-click"]').on('keydown', function (e) {
				if (e.which === 13) {
					e.preventDefault();
					e.stopPropagation();
					$(this).parents('form').find('button, input[type=button], input[type=submit], .btn').last().click();
					return false;
				}
			});
		};

		self.calendarBeforeShow = function (element) {
			if (!self.isDatePickerInitializedByErvCode()) {
				self.loadDatePickerDefaults();
			}

			var $datePickerDiv = $('#ui-datepicker-div');

			//gtranslate fix
			$datePickerDiv.addClass('notranslate');

			// Reposition datepicker when zoom is applied by accessibility tools
			setTimeout(function() {
				const datePickerElement = document.getElementById('ui-datepicker-div');
				const zoomContainerElement = document.getElementById('erv-body')

				self.userwayHelpers.setupResizeObserver(
					'#ui-datepicker-div',
					'#ui-datepicker-div',
					(targetElement, entry) => {
						const titleElement = targetElement.querySelector('.ui-datepicker-month');
						if (!titleElement) return;

						const fontSizeStr = window.getComputedStyle(titleElement).fontSize;
						const fontSize = parseFloat(fontSizeStr);

						targetElement.classList.remove('ui-datepicker-medium', 'ui-datepicker-wide');

						if (fontSize >= 20) {
							targetElement.classList.add('ui-datepicker-wide');
						} else if (fontSize > 25) {
							targetElement.classList.add('ui-datepicker-medium');
						}
					}
				);
				
				self.userwayHelpers.repositionElementBottomRelativeToInput(element, datePickerElement, zoomContainerElement);
			}, 0);

			if (self.$ervBody.find('#booking-widget').length === 0) { return false; }

			if (self.responsiveCommon.isDeviceSize('small')) {
				$datePickerDiv.wrap('<div class="datepicker-wrapper-inner"></div>');
				var $wrapperInner = $datePickerDiv.parent();
				$wrapperInner.wrap('<div id="datepicker-wrapper"></div>');
				setTimeout(function () {
					$datePickerDiv.attr('style', '');
					$datePickerDiv.addClass('fixed');

					if ($wrapperInner.length > 0) {
						$wrapperInner.prepend($('<button class="close-wrapper btn blue tiny">X</button>'));

						var $button = $wrapperInner.find('.close-wrapper');

						$button.on('click', function (e) {
							self.resetSmallDeviceCalendar($datePickerDiv);
						});
					}
				}, 15);
			} else {
				self.resetSmallDeviceCalendar($datePickerDiv);
			}
		};

		self.calendarOnClose = function (element) {
			element.focus();
			if (self.$ervBody.find('#booking-widget').length === 0) { return false; }

			var $datePickerDiv = $('#ui-datepicker-div');

			self.resetSmallDeviceCalendar($datePickerDiv);
		};

		self.initPickers = function () {
			$('.is-date.is-range, .is-date.is-range-withstart, .is-date.is-comparison-range, .is-date.is-search-range, .is-date.is-single').each(function () {
				self.initDatePicker($(this));
			});

			if ($('.is-time').length) {
				require(['jquerytimepicker'], function () {
					$('.is-time').each(function () {
						self.initTimePicker($(this));
					});
				});
			}

			var $datePickerDiv = $('#ui-datepicker-div');
			if ($datePickerDiv.length === 0) {
				return;
			}

			var resizeId, width;
			$(window).on('resize', function () {
				var newWidth = $(window).width();

				if (width !== newWidth) {
					width = newWidth;

					clearTimeout(resizeId);
					resizeId = setTimeout(function () {
						self.resetSmallDeviceCalendar($datePickerDiv);
					}, 60);
				}
			});
		};

		self.initFormSelects = function () {
			$('.is-select .select-trigger').on('click', function (e) {
				var $container = $(this).parent(),
					$select = $container.find('select');

				var size = $select.attr('size') == 1 ? $select.find('option').length : 1;
				$select.attr('size', size);

				$select.on({
					click: function () {
						$container.find('select').attr('size', 1);
					}
				});
			});
		};

		self.initResetButtons = function () {
			$('input[type="reset"]').on('click', function (e) {
				$('.ValidationSuccess').removeClass('ValidationSuccess')
				$('.ValidationFail').removeClass('ValidationFail');

				$('.input-validation-error').removeClass('input-validation-error')
				$('.input-validation-valid').removeClass('input-validation-valid');

				$('.valid').removeClass('valid');
			});
		};

		self.initInputNumbersOnly = function () {
			self.$ervBody.find('form').on('keypress', '[data-js="numbersonly"]', function (e) {
				var charCode = (e.which) ? e.which : e.keyCode;
				if (charCode > 31 && (charCode < 48 || charCode > 57)) {
					e.preventDefault();
					e.stopPropagation();
					return false;
				}
			});
		}


		self.resetSmallDeviceCalendar = function ($datePickerDiv) {
			if ($datePickerDiv.length > 0) {
				$datePickerDiv.removeClass('fixed');

				if ($datePickerDiv.parents('#datepicker-wrapper').length > 0) {
					$datePickerDiv.parent().unwrap();
					$datePickerDiv.unwrap();
					$datePickerDiv.parent().find($('.close-wrapper')).remove();
				}

				self.$ervBody.find('.hasDatepicker').datepicker('hide');
			}
		}

		self.dateValidation = function ($input) {
			if ($input.hasClass('ignore-blurreset'))
				return;

			if ($input.val() === '' && typeof ($input.data('val-required')) !== 'undefined') {
				$input.addClass('input-validation-error');
				$input.removeClass('input-validation-valid');
			} else {
				$input.removeClass('input-validation-error');
				$input.addClass('input-validation-valid');
				$input.parent().find('.field-validation-error').empty();
				$input.parents('.field').find('.custom-validation-message').addClass('hide');
			}
		}

		self.clearErrors = function ($container) {
			var $summary = $container.find('.validation-summary-errors');

			if ($summary.length > 0 && $summary.find('li').length === 0) {
				$summary.remove();
			}

			$container.find('.input-validation-error').each(function () {
				var $element = $(this);
				if ($element.parents('.field').find('.custom-validation-message:not(.hide)').length !== 1) {
					$element.removeClass('input-validation-error');
				}
			});
		}

		self.autocompleteFix = function ($inputs) {
			if (!$inputs || !$inputs.length) {
				return;
			}

			// autocomplete fix for IE Edge
			if (self.checks.isIEEdge()) {
				$inputs.attr('autocomplete', 'off');
				return false;
			}

			// autocomplete fix for mobile
			if ($inputs.length > 0) {
				$inputs.on('focus',
					function () {
						$(this).attr('autocomplete', 'off');
					});

				$inputs.on('blur',
					function () {
						$(this).removeAttr('autocomplete');
					});
			}
		}
	};

	ERVForms.prototype.initTimePicker = function ($picker) {
		var self = this,
			$input = $picker.find('input');

		if ($input.length > 0) {
			$input.timepicker({
				show2400: true,
				timeFormat: 'H:i',
				selectOnBlur: true,
				scrollDefault: '10:00'
			});

			$input.on('keypress', function (e) {
				var charCode = (e.which) ? e.which : e.keyCode,
					key = String.fromCharCode(charCode);
				var regex = /\d|\:/;
				if (!regex.test(key)) {
					e.preventDefault();
					e.stopPropagation();
					return false;
				}
			});
		}
		else {
			$input = null; // no time inputs found
		}

		self.autocompleteFix($input);

		$picker.find('.time-icon, label').on('click', function () { $(this).parent().find('input').focus(); });
	}

	ERVForms.prototype.initDatePicker = function ($picker) {
		var self = this;
		var $inputs = $picker.find('input'),
			$start = $inputs.filter('.start'),
			$end = $inputs.filter('.end');

		var isValidFormat = function ($element, value) {
			var pattern = $element.data('rule-regextest');
			return !pattern || new RegExp(pattern).test(value);
		}

		var getDefaultDatePickerDateFormat = function () {
			var regional = $.datepicker.regional[$('html').data('orglang')];
			return regional ? regional.dateFormat : '';
		}

		var getMaxDaysInFuture = function () {
			return $inputs.length ? $($inputs[0]).data('max-days-in-future') : undefined;
		}

		var getMaxYearsInFuture = function () {
			return $inputs.length ? $($inputs[0]).data('max-years-in-future') : undefined;
		}

		var calculateMaxDate = function (selectedValue) {
			var selectedDate = new Date(self.formatting.reverseShortDate(selectedValue))
			return selectedValue === '' || !isValidFormat($start, selectedValue)
				? 0
				: new Date(selectedDate.setFullYear(selectedDate.getFullYear() + getMaxYearsInFuture()));
		}

		var getDateFormat = function ($element) {
			var pattern = $element.data('rule-regextest');
			var placeholder = $element.attr('placeholder');
			return !pattern ? getDefaultDatePickerDateFormat() : placeholder.replace('yyyy', 'yy');
		}

		var setupFutureDatePicker = function ($start, $end, options) {
			$start.datepicker({
				minDate: options.minStartDate || 0,
				dateFormat: getDateFormat($start),
				beforeShow: function (element) {
					self.calendarBeforeShow(element);
				},
				onClose: function (selectedDate) {
					if (selectedDate) {
						$end.datepicker('option', 'minDate',
							selectedDate === '' || !isValidFormat($start, selectedDate) ? 0 : selectedDate);

						if (getMaxYearsInFuture()) {
							$end.datepicker('option', 'maxDate', calculateMaxDate(selectedDate));
						}
					}
					self.calendarOnClose(this);

				}
			});

			$end.datepicker({
				minDate: options.minEndDate || 0,
				maxDate: getMaxYearsInFuture() ? '+' + getMaxYearsInFuture() + 'Y' : '+150Y',
				dateFormat: getDateFormat($end),
				beforeShow: function (element) {
					self.calendarBeforeShow(element)
				},
				onClose: function (selectedDate) {
					if (selectedDate) {
						$start.datepicker('option', 'maxDate',
							selectedDate === '' || !isValidFormat($end, selectedDate) ? 0 : selectedDate);
					}
					self.calendarOnClose(this);
				}
			});

			$start.on("change", function () {
				if (!$(this).val()) {
					$end.datepicker("option", "minDate", options.minEndDate || 0);
				}
			});

			$end.on("change", function () {
				if (!$(this).val()) {
					$start.datepicker("option", "maxDate", null);
				}
			});
		}

		var $parentContainer = $picker.parents($picker.data('parentcontainer'));

		if ($picker.hasClass('is-comparison-range')) {
			$start.datepicker({
				dateFormat: getDateFormat($start),
				maxDate: 0,
				minDate: '-50Y',
				onClose: function (selectedDate) {
					if (selectedDate != '' && isValidFormat($start, selectedDate)) {
						$end.datepicker('option', 'minDate', selectedDate);
					}
					this.focus();
				}
			});

			$end.datepicker({
				dateFormat: getDateFormat($end),
				maxDate: 0,
				minDate: '-50Y',
				onClose: function (selectedDate) {
					if (selectedDate != '' && isValidFormat($end, selectedDate)) {
						$start.datepicker('option', 'maxDate', selectedDate);
					}
					this.focus();
				}

			});
		} else if ($picker.hasClass('is-range') && $picker.hasClass('is-future')) {
			setupFutureDatePicker($start, $end, {})

		} else if ($picker.hasClass('is-range') && $picker.hasClass('is-bti')) {
			$start.datepicker({
				dateFormat: getDateFormat($start),
				minDate: '-5Y',
				maxDate: '5Y',
				beforeShow: function (element) {
					self.calendarBeforeShow(element);
				},
				onClose: function (selectedDate) {
					$end.datepicker('option', 'minDate',
						selectedDate === '' || !isValidFormat($start, selectedDate) ? 0 : selectedDate);
					self.calendarOnClose(this);
				}
			});

			$end.datepicker({
				dateFormat: getDateFormat($end),
				minDate: '-5Y',
				maxDate: '5Y',
				beforeShow: function (element) {
					self.calendarBeforeShow(element)
				},
				onClose: function (selectedDate) {
					$start.datepicker('option', 'maxDate',
						selectedDate === '' || !isValidFormat($end, selectedDate) ? 0 : selectedDate);
					self.calendarOnClose(this);
				}
			});

		} else if ($picker.hasClass('is-range') && $picker.hasClass('is-healthdeclaration')) {
			setupFutureDatePicker($start, $end, {
				minStartDate: +8,
				minEndDate: +8
			});

		} else if ($picker.hasClass('is-range-withstart')) {
			var $withinInput = $parentContainer.find('.is-within-range input');

			$start.datepicker({
				dateFormat: getDateFormat($start),
				beforeShow: function (element) {
					self.calendarBeforeShow(element);
				},
				onClose: function (selectedDate) {
					$end.datepicker('option', 'minDate',
						selectedDate === '' || !isValidFormat($start, selectedDate) ? 0 : selectedDate);
					self.calendarOnClose(this);
					$withinInput.datepicker('option', 'minDate', selectedDate);
				}
			});

			$end.datepicker({
				dateFormat: getDateFormat($end),
				beforeShow: function (element) {
					self.calendarBeforeShow(element)
				},
				onClose: function (selectedDate) {
					$start.datepicker('option', 'maxDate',
						selectedDate === '' || !isValidFormat($end, selectedDate) ? 0 : selectedDate);
					self.calendarOnClose(this);
					$withinInput.datepicker('option', 'maxDate', selectedDate);
				}
			});
		} else if ($picker.hasClass('is-search-range')) {
			var fixEnterAndValidation = function ($element) {
				$element.blur();

				//prevent infinityloop in all IE
				if (!self.checks.isIE()) {
					$element.focus();
				}

				$element.click(function () {
					$(this).datepicker('show');
				});
			}

			$start.datepicker({
				maxDate: '+150Y',
				minDate: '-150Y',
				onClose: function () {
					fixEnterAndValidation($start);
					this.focus();
				}
			});

			$end.datepicker({
				maxDate: '+150Y',
				minDate: '-150Y',
				onClose: function () {
					fixEnterAndValidation($end);
					this.focus();
				}
			});

			$start.addClass('ignore-blurreset');
			$end.addClass('ignore-blurreset');

		} else if ($picker.hasClass('is-single') && $picker.hasClass('is-normal')) {

			$inputs.datepicker({
				maxDate: '+150Y',
				minDate: '-150Y',
				onClose: function () {
					this.focus();
				}
			});

		} else if ($picker.hasClass('is-single') && $picker.hasClass('is-future')) {
			var maxDate = getMaxDaysInFuture() ? '+' + getMaxDaysInFuture() + 'D' : '+150Y';
			$inputs.datepicker({
				maxDate: maxDate,
				minDate: '0',
				beforeShow: function (element) {
					self.calendarBeforeShow(element);
				},
				onClose: function () {
					self.calendarOnClose(this);
				}
			});

		} else if ($picker.hasClass('is-single') && $picker.hasClass('is-history')) {
			$inputs.datepicker({
				maxDate: '0',
				minDate: '-150Y',
				beforeShow: function (element) {
					self.calendarBeforeShow(element);
				},
				onClose: function () {
					self.calendarOnClose(this);
				}
			});

		} else if ($picker.hasClass('is-single') && $picker.hasClass('is-birthdate')) {
			$inputs.datepicker(
				{
					maxDate: '0',
					minDate: '-100Y',
					yearRange: '-100:+ 0',
					beforeShow: function (element) {
						self.calendarBeforeShow(element);
					},
					onClose: function () {
						self.calendarOnClose(this);
					}
				});

		} else if ($picker.hasClass('is-single') && $picker.hasClass('is-mindate')) {
			$inputs.datepicker({
				maxDate: '+150Y',
				minDate: new Date($picker.attr('data-mindate')),
				onClose: function () {
					this.focus();
				}
			});
			$end.addClass('ignore-blurreset');

		} else if ($picker.hasClass('is-single') && $picker.hasClass('is-within-range') && $parentContainer.length === 1) {
			var $startPeriod = $parentContainer.find('.start'),
				$endPeriod = $parentContainer.find('.end');

			if ($startPeriod.length === 1 && $endPeriod.length === 1) {
				$inputs.datepicker({
					maxDate: $endPeriod.val() === '' ? '+150Y' : $endPeriod.val(),
					minDate: $startPeriod.val() === '' ? '0' : $startPeriod.val(),
					onClose: function (selectedDate) {
						this.focus();
						var date = new Date(self.formatting.reverseShortDate(selectedDate));

						if (date > new Date(self.formatting.reverseShortDate($endPeriod.val())) || date < new Date(self.formatting.reverseShortDate($startPeriod.val()))) {
							$(this).val($startPeriod.val());
						}
					}
				});
			} else {
				$inputs.datepicker({
					maxDate: '+150Y',
					minDate: 0,
					onClose: function () {
						this.focus();
					}
				});
			}
		} else {
			$inputs = null; // no date inputs found
		}

		// clean validation
		if ($inputs != null && $inputs.length > 0) {
			$inputs.each(function () {
				var $input = $(this);
				if ($input.data('val') === true) {
					$input.on('blur', function (e) {
						setTimeout(function () {
							if ($input.val().length === 0) {
								e.preventDefault();
								e.stopPropagation();

								$input.valid();
							}
						}, 250);
					});
				}
			});
		}

		self.autocompleteFix($inputs);

		$picker.find('.date-icon, label').on('click', function () { $(this).parent().find('input').focus(); });
	}

	ERVForms.prototype.disableFormElementsInContainer = function ($container, disable, removeValidation) {
		if (removeValidation === undefined) {
			removeValidation = true;
		}

		$container.find('input, select, button, label').each(function () {
			var $this = $(this);

			$this.prop('disabled', disable);

			if (!disable) {
				$this.parent().find('label').removeClass('disabled');
			} else {
				$this.parent().find('label').addClass('disabled');
			}
		});

		if (removeValidation) {
			$container.find('.input-validation-error').removeClass('input-validation-error');
		}
	};

	ERVForms.prototype.setupDropdownTogglers = function ($togglers) {
		$.each($togglers,
			function () {
				var $this = $(this),
					$triggerElement = $this.find('select');

				var $childrenContainer = $this.parent().find('[data-toggle="children"]');

				if ($triggerElement.find('option:selected').val() === 'Other')
					$childrenContainer.removeClass('hide');
				$triggerElement.change(function () {
					$childrenContainer.toggleClass('hide', $(this).find('option:selected').val() !== 'Other');
				});

			});
	}

	ERVForms.prototype.setupRadioTogglers = function ($togglers, parentSelector) {
		var parseRawValue = function (rawValue) {
			if (rawValue === undefined || rawValue === '') {
				return '';
			}

			return rawValue;
		}

		$.each($togglers, function () {
			var $this = $(this),
				$triggerElement = $this.find('input[type=radio]');

			var $childrenContainer, $childrenContainer2;

			if (parentSelector != undefined) {
				$childrenContainer = $this.parents(parentSelector).find('[data-toggle="children"]');
				$childrenContainer2 = $this.parents(parentSelector).find('[data-toggle="children2"]');
			} else {
				$childrenContainer = $this.parent().find('[data-toggle="children"]');
				$childrenContainer2 = $this.parent().find('[data-toggle="children2"]');
			}

			var childrenContainerCount = $this.parent().find('[data-toggle="children"], [data-toggle="children2"]').length;

			if (childrenContainerCount == 1) {
				// Show children if true is checked
				if ($triggerElement.filter('[data-value="true"]').prop("checked")) {
					$childrenContainer.removeClass('hide');
				}
			}
			else if (childrenContainerCount == 2) {
				// Show children if true is checked
				if ($triggerElement.filter('[data-value="true"]').prop("checked")) {
					$childrenContainer.removeClass('hide');
					$childrenContainer2.addClass('hide');
				} else if ($triggerElement.filter('[data-value="false"]').prop("checked")) {
					$childrenContainer.addClass('hide');
					$childrenContainer2.removeClass('hide');
				} else if ($triggerElement.filter('[data-value="unsure"]').prop("checked")) {
					$childrenContainer.addClass('hide');
					$childrenContainer2.addClass('hide');
				}
			}

			$triggerElement.change(function () {
				$this.find('input[data-js="value-raw"]')
					.attr('value', parseRawValue($(this).data('value-raw')));
				if ($(this).data('value') === 'unsure') {
					$childrenContainer.addClass('hide');
					$childrenContainer2.addClass('hide');
				} else {
					$childrenContainer.toggleClass('hide', !$(this).data('value'));
					$childrenContainer2.toggleClass('hide', $(this).data('value'));
				}

				if ($childrenContainer.hasClass('hide')) {
					$childrenContainer.find('input[data-val="true"]').removeClass('input-validation-error');
				} else {
					$childrenContainer.find('input[data-val="true"]').removeClass('input-validation-valid');
				}

				if ($childrenContainer2.hasClass('hide')) {
					$childrenContainer2.find('input[data-val="true"]').removeClass('input-validation-error');
				} else {
					$childrenContainer2.find('input[data-val="true"]').removeClass('input-validation-valid');
				}
			});
		});
	};

	ERVForms.prototype.updateValidation = function ($input) {
		var form = $input.closest('form')
			.removeData('validator')
			.removeData('unobtrusiveValidation');

		$.validator.unobtrusive.parse(form);
	};

	ERVForms.prototype.activateLoading = function ($element, shouldSubmit, e) {
		if (typeof (e) !== 'undefined') {
			e.preventDefault();
			e.stopPropagation();
		}

		if (!$element.hasClass('loading')) {
			$element.addClass('loading disabled is-inactive');

			if (shouldSubmit) {
				setTimeout(function () {
					if ($element[0].tagName === 'FORM') {
						$element.submit();
					} else {
						$element.parents('form').submit();
					}
				}, 20);
			}
		}
	}

	ERVForms.prototype.activateLoadingHorizontal = function ($element, themeDark) {
		var loadingElement = '<div class="loading-overlay"><div class="loading-horizontal"></div></div>';

		if (themeDark) {
			loadingElement = '<div class="loading-overlay dark"><div class="loading-horizontal"></div></div>';
		}

		$(loadingElement).insertAfter($element);
	}

	ERVForms.prototype.deactivateLoadingHorizontal = function ($element) {
		$element.parent().find('.loading-overlay').remove();
	}

	ERVForms.prototype.deactivateLoading = function ($element) {
		$element.removeClass('loading disabled is-inactive');
	}

	ERVForms.prototype.init = function () {
		var self = this;

		document.addEventListener('keydown', (e) => {
			if (e.target.matches('input[type="number"]') && ['e', 'E', '+', '-'].includes(e.key)) {
				e.preventDefault();
			}
		});

		$('form').bind('invalid-form.validate', function (form, validator) {
			var $form = $(this);

			if ($form.data('js') === 'novalidationsummary')
				return;

			if (typeof (validator.errorList) === 'undefined' || validator.errorList.length === 0)
				return;

			self.validationSummary.updateErrorFieldsLabels(validator, $form);

			self.validationSummary.setErrorFieldLabels();

			if (self.$ervBody.find('.validation-summary-errors ul li').length > 1) {
				$('html, body').animate({
					scrollTop: 0
				},
					400);
			} else {
				$('#' + validator.errorList[0].element.id).focus();
			}

			self.deactivateLoading($form.find('.btn.loading'));
		});

		if ($('form').length > 0 && $.data($('form')[0], 'validator') !== undefined) {
			var settings = $.data($('form')[0], 'validator').settings;

			settings.submitHandler = function (form) {
				$(form).find('.validation-summary-errors').remove();
				form.submit();
			};
		}

		self.setEnterTriggerClick();
		self.initPickers();
		self.initFormSelects();
		self.initInputNumbersOnly();
		self.initResetButtons();
		self.ervTagit.init();
		self.episerverFormsHelpers.init();
		self.initFormWithLoader();

		if (self.checks.isIos()) {
			window.addEventListener('pagehide', function () {
				self.deactivateLoading(self.$ervBody.find('.loading'));
			});
		}

		//on blur instant feedback
		setTimeout(function () {
			self.$ervBody.find('input[data-val="true"]').on('blur', function () {
				var $input = $(this);

				$input.val($input.val().trim());

				//Datepicker need to run .valid() later
				if (!$input.hasClass('hasDatepicker')) {
					$input.valid();

					if (self.$ervBody.find('.input-validation-error').length === 0) {
						self.$ervBody.find('.validation-summary-errors').addClass('hide');
					} else {
						self.$ervBody.find('.validation-summary-errors').removeClass('hide');
					}
				}
			});
		}, 200);
	}

	return ERVForms;
})